<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'sort', validatorRules.sort]" placeholder="请输入排序" style="width: 100%"/>
        </a-form-item>
        <a-form-item  label="系列" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag ref="seriesnumberRef" dictCode="gallery_series_name" v-decorator="[ 'seriesnumber', validatorRules.seriesnumber]" :trigger-change="true" @change="handleSeriesNumberChange" placeholder="请输入序列名称"></j-dict-select-tag>
        </a-form-item>
        <a-form-item v-show="false" label="系列名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input readonly v-decorator="[ 'series']" placeholder="请输入序列名称"></a-input>
        </a-form-item>
        <a-form-item label="样块编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sampleplatenumber', validatorRules.sampleplatenumber]" placeholder="请输入样块编号"></a-input>
        </a-form-item>
        <a-form-item label="样块名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sampleplate', validatorRules.sampleplate]" placeholder="请输入样块名称"></a-input>
        </a-form-item>
        <a-form-item label="套路编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'routinenumber', validatorRules.routinenumber]" placeholder="请输入套路编号"></a-input>
        </a-form-item>
        <a-form-item label="套路名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'routine', validatorRules.routine]" placeholder="请输入套路名称"></a-input>
        </a-form-item>
        <a-form-item label="基材" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'basematerial', validatorRules.basematerial]" placeholder="请输入基材"></a-input>
        </a-form-item>
        <a-form-item label="面材" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'facematerial', validatorRules.facematerial]" placeholder="请输入面材"></a-input>
        </a-form-item>
        <a-form-item label="样板图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
           <j-upload :is-multiple="false" :max-count="1" v-decorator="[ 'imageurl', validatorRules.imageurl]" placeholder="请上传样板图片"  :uploadAction="url.upload" :trigger-change="true" ></j-upload>
        </a-form-item>
        <a-form-item label="720度效果图地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'url', validatorRules.url]" placeholder="请输入720度效果图地址"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  
  import  JUpload from '@/components/common/JUpload.vue'

  export default {
    name: "GisOrangehomeGalleryBaseinfoModal",
    components: { 
      JDate,JUpload
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          seriesnumber: { rules: [{
            required: true,
            message: '请选择系列！',
            trigger: 'change'
          }]},
          series: {rules: [
          ]},
          routinenumber: {rules: [
          ]},
          routine: {rules: [
          ]},
          sampleplatenumber: { rules: [{
            required: true,
            message: '请输入样块编号！',
          }]},
          sampleplate: { rules: [{
            required: true,
            message: '请输入样块名称！',
          }]},
          basematerial: {rules: [
          ]},
          facematerial: {rules: [
          ]},
          imageurl: {rules: [
          ]},
          url: {rules: [
          ]},
          sort: { rules: [{
            required: true,
            message: '请输入序号！',
          }]},
          createBy: {rules: [
          ]},
          createDate: {rules: [
          ]},
          updateBy: {rules: [
          ]},
          updateDate: {rules: [
          ]},
          remarks: {rules: [
          ]},
          delFlag: {rules: [
          ]},
        },
        url: {
          add: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/add",
          edit: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/edit",
          upload:window._CONFIG['domianURL']+"/jpgallery.base/gisOrangehomeGalleryBaseinfo/upload"
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'seriesnumber','series','routinenumber','routine','sampleplatenumber','sampleplate','basematerial','facematerial','imageurl','url','sort','createBy','createDate','updateBy','updateDate','remarks','delFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'seriesnumber','series','routinenumber','routine','sampleplatenumber','sampleplate','basematerial','facematerial','imageurl','url','sort','createBy','createDate','updateBy','updateDate','remarks','delFlag'))
      },
      handleSeriesNumberChange(val){
        if(val||val===0){
          this.$nextTick(()=>{
            let series=this.$refs.seriesnumberRef.getSelectLabels();
            this.form.setFieldsValue({series});
          })
        }
      }
    }
  }
</script>